import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { Holiday } from "./holiday";
import { Holiday as H, holiday } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, edit }: Props) {
  const { t } = useTranslation();
  const [calendarName, setCalendarName] = React.useState(formData.name);
  const [holidays, setHolidays] = React.useState<H[]>(
    [...formData.holidays].sort((current, next) =>
      new Date(current.day) < new Date(next.day) ? -1 : 1,
    ),
  );

  const editName = (name: string) => {
    setCalendarName(name);
    edit({ ...formData, name, holidays });
  };

  const editHoliday = (index: number, holiday: H) => {
    const updatedHolidays = [...holidays];

    updatedHolidays[index] = holiday;
    setHolidays(updatedHolidays);
    edit({ ...formData, name: calendarName, holidays: updatedHolidays });
  };

  const addHoliday = () => setHolidays([...holidays, { ...holiday }]);

  const removeHoliday = (index: number) => {
    const updatedHolidays = holidays.filter((_, i) => i !== index);

    setHolidays(updatedHolidays);
    edit({ ...formData, name: calendarName, holidays: updatedHolidays });
  };

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("calendarHolidays.edition.nameTitle")}
        </h2>
        <TextInput
          placeholder={t("calendarHolidays.edition.namePlaceholder")}
          value={calendarName}
          input={editName}
        />
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("calendarHolidays.edition.holidaysTitle")}
        </h2>
        {holidays.map((holiday, index) => (
          <Holiday
            key={holiday.uuid}
            holiday={holiday}
            onChange={(updatedHoliday) => editHoliday(index, updatedHoliday)}
            onRemove={() => removeHoliday(index)}
          />
        ))}
        <button className={styles.button} type="button" onClick={addHoliday}>
          + {t("calendarHolidays.edition.addHoliday")}
        </button>
      </div>
    </div>
  );
}

export { Form };
